// extracted by mini-css-extract-plugin
export var link = "LinkList-module--link--drANZ";
export var linksWrapper = "LinkList-module--linksWrapper--8qTwH";
export var title = "LinkList-module--title--rA3WC";
export var wrapper = "LinkList-module--wrapper--6WNdT";